import DBTI from "../../../../src/events/2022/04/dbti/main";
import * as React from 'react';
export default {
  DBTI,
  React
};